import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { SituacaoTable } from '../components/situacao/SituacaoTable';
import { SituacaoFormModal } from '../components/situacao/SituacaoFormModal';
import type { Situacao } from '../types/entities';

export const Situacoes: React.FC = () => {
  const [selectedSituacao, setSelectedSituacao] = useState<Situacao | undefined>();
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateNew = () => {
    setSelectedSituacao(undefined);
    setModalOpen(true);
  };

  const handleEdit = (situacao: Situacao) => {
    setSelectedSituacao(situacao);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setSelectedSituacao(undefined);
    // bump refreshKey so the table reloads
    setRefreshKey((k) => k + 1);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedSituacao(undefined);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-4 gap-2">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-bold" style={{ color: '#3d2b56' }}>
                Gestão de Situações
              </h1>
              <p className="text-xs mt-0.5" style={{ color: '#9E9E9E' }}>
                Gerencie as situações dos documentos
              </p>
            </div>

            <button
              onClick={handleCreateNew}
              className="px-3 py-1 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-1 focus:ring-offset-1 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Nova Situação
            </button>
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <SituacaoTable
              onEdit={handleEdit}
              refreshKey={refreshKey}
              onDeleted={() => setRefreshKey((k) => k + 1)}
            />

            {modalOpen && (
              <SituacaoFormModal
                situacao={selectedSituacao}
                onClose={handleCancel}
                onSuccess={handleSuccess}
              />
            )}
          </div>
        </div>

        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>
    </div>
  );
};